import styled from "styled-components";

export const StyledCareer = styled.div``;
